var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#FEF1DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3885 32.4523L24.4817 33.5532C23.2796 34.2472 21.7223 33.8475 21.0163 32.6247L20.5377 31.7956C19.8436 30.5935 20.2434 29.0362 21.4662 28.3302L24.886 26.3558C26.0881 25.6618 27.6454 26.0615 28.3514 27.2843L28.8899 28.217C29.2249 28.7974 29.9442 28.9901 30.5245 28.655C31.1048 28.32 31.2975 27.6007 30.9625 27.0204L30.424 26.0877C29.0718 23.7457 26.0522 22.919 23.6894 24.2832L20.2696 26.2576C17.9275 27.6098 17.1009 30.6295 18.465 32.9922L18.9437 33.8213C20.2959 36.1633 23.3155 36.99 25.6783 35.6258L27.5851 34.5249C28.1654 34.1899 28.3582 33.4706 28.0231 32.8903C27.6881 32.31 26.9688 32.1173 26.3885 32.4523Z",
    fill: "#F79009"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3216 20.4575L28.6635 21.4148C28.0832 21.7499 27.8905 22.4691 28.2255 23.0495C28.5606 23.6298 29.2798 23.8225 29.8601 23.4874L31.5182 22.5301C32.7203 21.8361 34.2776 22.2359 34.9836 23.4587L35.4623 24.2877C36.1563 25.4899 35.7566 27.0471 34.5337 27.7531L31.3212 29.6079C30.1191 30.3019 28.5618 29.9022 27.8558 28.6793L27.437 27.9539C27.1019 27.3736 26.3827 27.1809 25.8023 27.5159C25.222 27.851 25.0293 28.5702 25.3644 29.1506L25.7832 29.876C27.1354 32.218 30.155 33.0447 32.5178 31.6805L35.7303 29.8257C38.0724 28.4736 38.899 25.4539 37.5349 23.0911L37.0562 22.2621C35.704 19.92 32.6637 19.1054 30.3216 20.4575Z",
    fill: "#F79009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.b33d532d2ab924fe3cf7ceea94b304c1.svg";
export { ForwardRef as ReactComponent };